module.exports = __webpack_public_path__ + "static/media/17UN-Women8.69213b76.jpg";